import { useState } from "react";
import { CalendarDays, X } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Calendar } from "./ui/calendar";
import { fmtDate } from "../lib/api";

const toDate = (s) => (s ? new Date(`${s}T00:00:00`) : undefined);

export const DatePicker = ({ value, onChange, placeholder = "Pick date", clearable, testid, className = "" }) => {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className={`flex items-center gap-2 h-9 px-3 border border-line2 bg-canvas text-sm font-mono hover:border-brand transition-colors ${className}`}>
          <CalendarDays className="h-4 w-4 text-brand" />
          <span className={value ? "text-ink" : "text-muted-c"}>{value ? fmtDate(value) : placeholder}</span>
          {clearable && value && (
            <X className="h-3.5 w-3.5 ml-auto text-muted-c hover:text-ink" data-testid={`${testid}-clear`}
              onClick={(e) => { e.stopPropagation(); onChange(""); }} />
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-surface border-line2" align="start" data-testid={`${testid}-calendar`}>
        <Calendar mode="single" selected={toDate(value)} defaultMonth={toDate(value)}
          onSelect={(d) => { if (d) { onChange(d.toLocaleDateString("en-CA")); setOpen(false); } }}
          classNames={{
            day_selected: "bg-brand text-onbrand hover:bg-brand hover:text-onbrand focus:bg-brand focus:text-onbrand",
            day_today: "border border-brand/60 text-brand",
          }} />
      </PopoverContent>
    </Popover>
  );
};
